import api from '../api';

export interface NotificationCounts {
  pending_claims: number;
  pending_tires: number;
  total: number;
}

export interface NotificationCountsResponse {
  success: boolean;
  data: NotificationCounts;
}

const API_BASE = '/admin/notifications';

export const notificationService = {
  /**
   * Get notification counts for admin
   */
  async getCounts(): Promise<NotificationCounts> {
    const response = await api.get<NotificationCountsResponse>(`${API_BASE}/counts`);
    return response.data.data;
  }
};

